// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2aeaf0b3","455":"f4e8ce14","977":"e8ce1b5f"}[chunkId] + ".chunk.js";
};